import axios from 'axios';
const SETTINGS_CUSTOMER_PATH = '/setting/customer';

export const getCustomerSettings = () => {
  return axios.get(`${process.env.REACT_APP_API_URL}${SETTINGS_CUSTOMER_PATH}`);
};
